module.exports = __webpack_public_path__ + "img/erweima.ab1e62d5.png";